import { Loader } from '@mantine/core';
import { Icon, variants } from '@uag/react-core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AttachmentType } from 'api/models';
import { humanFileSize } from 'utils/fileSize';

type RequestAttachmentProps = {
    fileName?: string | null;
    id: string;
    attachmentType: keyof typeof AttachmentType;
    fileSizeBytes?: number | null;
    onClick: () => Promise<void>;
};
export const RequestAttachment = ({ fileName, id, attachmentType, fileSizeBytes, onClick }: RequestAttachmentProps) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = () => {
        setIsLoading(true);
        onClick().finally(() => setIsLoading(false));
    };

    return (
        <div key={id} className="border-border-default w-full border border-solid px-3 py-2">
            <div className="flex w-full cursor-pointer content-center gap-2 select-none" onClick={handleClick}>
                <div className="grow truncate">
                    <p className="truncate text-base">{fileName}</p>
                    <p className="text-text-light text-sm">
                        {t(attachmentType)} {fileSizeBytes && `- ${humanFileSize(fileSizeBytes)}`}
                    </p>
                </div>
                {isLoading && <Loader className="h-6 w-6 border-2" variant={variants.loader.loadingAnimation} />}
                {!isLoading && <Icon className="mt-0.5" icon="file_download" size="2xl" />}
            </div>
        </div>
    );
};
